/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck

export type FieldPath<P, S> = {
  _PATH_: string & { _BRAND_: P & S }
}

export type PathProxy<P, S> = FieldPath<P, S> & {
  [K in keyof S]: PathProxy<P, S[K]>
}

const IdPath = { _PATH_: "" } as FieldPath<any, any>

export function pathProxy<S, P = S>(
  parent: FieldPath<P, S> = IdPath as any
): PathProxy<P, S> {
  return new Proxy(parent as any, {
    get(target: any, key: any) {
      // React and DevTools probe objects with Symbol keys; ignore them for path building.
      if (typeof key === "symbol") return Reflect.get(target, key)
      if (key in target) return target[key]
      return pathProxy<any, any>({
        _PATH_: `${parent._PATH_ && parent._PATH_ + "."}${key}`,
      } as any)
    },
  })
}
